import type { ComponentEditorMetaDataDefinition } from '../types';

import { documentTypeUtils } from '@wix/santa-editor-utils';

const metaData: ComponentEditorMetaDataDefinition = {
  skipInQuickEditPanel: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};

export default metaData;
